// Any configuration in the.env file needs to be prefixed with VUE_APP
// This class helps to parse configuration ensuring it is required
class Config {
    microservices = {
        // Add microservices
    };

    constructor() {
        this.microservices = {
            auth: this.getRequiredArg('VUE_APP_WHIZEO_AUTH'),
            reports: this.getRequiredArg('VUE_APP_WHIZEO_SNOWFLAKE_REPORTING'),
            supportToolsApi: this.getRequiredArg('VUE_APP_WHIZEO_SUPPORT_TOOLS_API'),
            clientList: this.getRequiredArg('VUE_APP_CLIENT_LIST'),
            validateLfClient: this.getRequiredArg('VUE_APP_VALIDATE_LFCLIENT'),
            updateSatisfactionLevel: this.getRequiredArg('VUE_APP_CLIENT_UPDATE_SATISFACTION_LEVEL'),
            createClient: this.getRequiredArg('VUE_APP_CREATE_CLIENT'),
            createPiUser: this.getRequiredArg('VUE_APP_CREATE_PI_USER'),
            clientCampaignApi: this.getRequiredArg('VUE_APP_WHIZEO_CLIENTCAMPAIGNS_API'),
            clientWidgetApi: this.getRequiredArg('VUE_APP_WHIZEO_CLIENTWIDGETS_API'),
            chatApi: this.getRequiredArg('VUE_APP_CHAT_API'),
        };
    }

    getRequiredArg(name) {
        const value = process.env[name];
        if (!value) {
            throw new Error(`Config parameter '${name}' required`);
        }
        return value;
    }
}

export default new Config();
